import Vue from 'vue'
import Vuex from 'vuex'
import { login } from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      token: localStorage.getItem('admin_token') || '',
      info: JSON.parse(localStorage.getItem('admin_info') || 'null')
    },
    sidebar: {
      collapsed: false
    }
  },

  getters: {
    token: state => state.user.token,
    adminInfo: state => state.user.info,
    sidebarCollapsed: state => state.sidebar.collapsed
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.user.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_ADMIN_INFO(state, info) {
      state.user.info = info
      localStorage.setItem('admin_info', JSON.stringify(info))
    },
    CLEAR_USER(state) {
      state.user.token = ''
      state.user.info = null
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebar.collapsed = !state.sidebar.collapsed
    }
  },

  actions: {
    async login({ commit }, credentials) {
      const res = await login(credentials)
      const { token, adminInfo } = res.data || {}
      if (!token) throw new Error('登录失败：未获取到 token，请重试')
      if (!adminInfo) throw new Error('登录失败：未获取到用户信息，请重试')
      commit('SET_TOKEN', token)
      commit('SET_ADMIN_INFO', adminInfo)
      return res
    },

    logout({ commit }) {
      commit('CLEAR_USER')
    },

    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    }
  }
})
